
<template>
  <ValidationProvider
    :ref="validationProviderRef"
    :mode="veeValidateInteractionMode"
    :rules="rules"
    :vid="validationProviderRef"
    :debounce="validationDelay"
    :name="label"
    :immediate="true"
  >
    <v-text-field
      :id="validationProviderRef"
      v-model="mutableValue"
      slot-scope="{ errors }"
      :data-cy="dataCy"
      :color="color"
      :class="extraClass"
      :counter="counter ? rules.max: null"
      :errorMessages="errors"
      :label="label ? displayedLabel : null"
      :required="isRequired"
      :hideDetails="hideDetails"
      :disabled="disabled"
      :readonly="readonly"
      :style="cssVars"
      :type="type"
      :suffix="suffix"
      v-bind="$attrs"
      v-on="$listeners"
      @wheel="onWheel"
    >
      <template v-slot:append>
        <div
          v-if="$slots.customAppend"
        >
          <slot
            name="customAppend"
          />
        </div>
      </template>
      <template v-slot:prepend-inner>
        <div
          v-if="$slots.customPrependInner"
        >
          <slot
            name="customPrependInner"
          />
        </div>
      </template>
    </v-text-field>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import validationProviderHelperMixin from '@/components/shared/widgets/forms/validationHelper/validationProviderHelperMixin';

export default {
    components: {
        ValidationProvider,
    },
    mixins: [
        validationProviderHelperMixin,
    ],
    props: {
        label: {
            type: String,
            default: '',
        },
        rules: {
            type: Object,
            default: () => ({ required: false, max: 200 }),
        },
        formatNumber: {
            type: Boolean,
            default: false,
        },
        extraClass: {
            type: String,
            default: null,
        },
        value: {
            type: [String, Number],
            default: null,
        },
        hideDetails: {
            type: [String, Boolean],
            default: false,
        },
        color: {
            type: String,
            default: '#003876',
        },
        counter: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        cssVars: {
            type: Object,
            default: undefined,
        },
        type: {
            type: String,
            default: 'text',
        },
        dataCy: {
            type: String,
            default: '',
        },
        suffix: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            mutableValue: null,
        };
    },
    computed: {
        isRequired() {
            return Object.keys(this.rules).some(rule => (rule === 'required' && this.rules[rule]));
        },
        displayedLabel() {
            return `${this.label} ${this.isRequired ? '*' : ''}`;
        },
    },
    watch: {
        value: {
            handler(newValue) {
                // We format the number to replace , by .
                // If we need other formatter for inputs,
                // convert this into a methods
                this.mutableValue = (this.formatNumber) && typeof newValue === 'string'
                    ? this.formatValue(newValue) : newValue;
                if (!!this.mutableValue && this.mutableValue !== '') {
                    this.$nextTick(async () => {
                        const res = await this.validateValidationProvider();
                        if (res?.valid) this.validateValidationProvider(false);
                    });
                }
            },
            immediate: true,
        },
    },
    methods: {
        formatValue(value) {
            return value ? value.replace(',', '.') : '';
        },
        onWheel(event) {
            if (this.type === 'number') {
                event.preventDefault();
            }
        },
    },
};
</script>
<style scoped>
  ::v-deep .v-text-field--outlined fieldset {
    border-color: var(--border-color) !important;
  }
</style>
